import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=62ff5bf8"
import script from "./menu.vue?vue&type=script&lang=ts"
export * from "./menu.vue?vue&type=script&lang=ts"
import style0 from "./menu.vue?vue&type=style&index=0&id=62ff5bf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports